// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 613) return "static/chunks/613-67a6bf5f0bdbe8a9.js";
	if (chunkId === 694) return "static/chunks/694-b1f993dee98706e7.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"169dbb4908c2df83","205":"67e56ec58883c7b0","319":"0cbc2894a3f1b950","340":"5b13ea54f42919af","367":"ab6a0285c9c2413d","639":"e7b660adfa99260e","748":"6c8f27812ced2296"}[chunkId] + ".js";
};